module.exports = __webpack_public_path__ + "img/empoli-logo-icon.454e1458.png";